{
  "general": {
    "retry": "다시 시도",
    "cancel": "취소",
    "back_to_home": "홈으로 돌아가기",
    "back": "뒤로",
    "menu": "메뉴",
    "close": "닫기",
    "edit": "편집",
    "delete": "삭제",
    "complate": "완료",
    "approve": "승인",
    "select_all_users": "모든 사용자 선택",
    "deselect_all_users": "모든 사용자 선택 해제",
    "search": "검색",
    "share": "공유",
    "suggestion": "제안",
    "user": "사용자",
    "all_users": "모든 Metamory 사용자",
    "group": "그룹",
    "album": "앨범",
    "address_book": "주소록",
    "other": "기타",
    "later": "나중에",
    "storage": "스토리지",
    "error": "오류",
    "append_photo": "사진 추가",
    "delete_photo": "사진 삭제",
    "remove_from": "{{name}}에서 제거",
    "removed_photo_from": "{{name}}에서 사진을 제거했습니다",
    "error_occurred": "오류가 발생했습니다",
    "created": "{{name}}을(를) 생성했습니다",
    "loading": "불러오는 중...",
    "change": "변경",
    "password": "비밀번호",
    "email": "이메일",
    "set": "설정",
    "copied_clipboard": "클립보드에 복사했습니다",
    "copied_clipboard_error": "클립보드 복사에 실패했습니다",
    "updated": "업데이트했습니다",
    "please_select": "선택해 주세요",
    "appended": "추가했습니다",
    "deleted": "삭제했습니다",
    "login": "로그인",
    "wip": "작업 중",
    "coming_soon": "곧 제공됩니다",
    "photos_num": "{{num}}장의 사진",
    "upgrade_plan": "플랜 업그레이드",
    "reload_page": "페이지 새로고침",
    "long_session_message": "이 페이지를 오랫동안 사용 중입니다. 최신 정보를 받기 위해 새로고침하시겠습니까?",
    "reload": "새로고침",
    "open": "열기"
  },
  "header": {
    "profile": "프로필",
    "plan": "플랜",
    "setting": "설정",
    "help": "도움말 및 피드백",
    "about": "Metamory 소개",
    "logout": "로그아웃",
    "select_icon": "아이콘 선택"
  },
  "feature": {
    "home": "홈",
    "dm": "DM",
    "favorite": "즐겨찾기",
    "my_photo": "내 사진",
    "my_album": "내 앨범",
    "share_album": "공유 앨범",
    "notification": "알림",
    "invitation": "초대",
    "search_photo": "사진 검색",
    "reaction": "리액션",
    "trash": "휴지통"
  },
  "time": {
    "just_now": "방금 전",
    "minute_ago": "1분 전",
    "minutes_ago": "{{num}}분 전",
    "hour_ago": "1시간 전",
    "hours_ago": "{{num}}시간 전",
    "yesterday": "어제",
    "days_ago": "{{num}}일 전",
    "month_ago": "1개월 전",
    "months_ago": "{{num}}개월 전",
    "year_ago": "1년 전",
    "years_ago": "{{num}}년 전"
  },
  "upload": {
    "upload_photo": "사진 업로드",
    "auto_upload_photo": "사진 자동 업로드",
    "uploading_photos": "사진 업로드 중",
    "drag_over": "업로드하려면 사진을 놓으세요",
    "upload_failed": "업로드에 실패했습니다",
    "upload_success": "업로드에 성공했습니다",
    "storage_over_error": "저장 용량을 초과했습니다",
    "file_count_over_error": "파일 개수 상한에 도달했습니다",
    "file_format_error": "허용되지 않는 데이터 파일입니다(예: 해상도가 너무 큼 등)",
    "file_break_error": "파일이 손상되었습니다",
    "file_size_lower_error": "파일 크기가 너무 작습니다(최소 64KB)",
    "file_size_upper_error": "파일 크기가 너무 큽니다(최대 100MB)",
    "iligal_data_error": "잘못된 데이터입니다",
    "netrowk_error": "네트워크 오류",
    "cancel_error": "취소되었습니다",
    "other_error": "오류",
    "capacity_error": "용량 초과",
    "edit_icon": "아이콘 편집"
  },
  "photo_list": {
    "selected": "{{num}}개 선택됨",
    "selected_limit": "선택 가능한 최대 개수는 {{num}}개입니다",
    "footer": {
      "download": "다운로드",
      "download_zip": "zip으로 다운로드",
      "zip_compressing": "zip 압축 중...",
      "append": "추가",
      "compare": "비교",
      "delete": "삭제",
      "download_error": "다운로드 오류",
      "download_success": "{{num}}장의 사진을 다운로드했습니다",
      "delete_confirm": "선택한 {{num}}장의 사진을 삭제하시겠습니까?",
      "delete_success": "{{num}}장의 사진을 삭제했습니다"
    },
    "append_menu": {
      "new_album": "새 앨범 만들기",
      "public_album": "공개 앨범",
      "public_album_lock": "공개 앨범(비밀번호 잠금)"
    }
  },
  "sort": {
    "append_time_new": "추가된 순서",
    "append_time_old": "추가된 순서(오래된 순)",
    "myphoto_append_time_new": "촬영일 순서",
    "myphoto_append_time_old": "촬영일 순서(오래된 순)",
    "updated_at": "업데이트 순서",
    "reverse_updated_at": "업데이트 순서(오래된 순)",
    "name_asc": "이름(A-Z)",
    "name_desc": "이름(Z-A)"
  },
  "photo": {
    "view_detail": "사진 상세 보기",
    "delete_from_album": "앨범에서 삭제",
    "delete": "삭제",
    "delete_confirm": "사진을 휴지통으로 이동할까요?",
    "delete_confirm_description": "앨범이나 DM 등 다른 곳에서도 삭제됩니다.",
    "user_tag": "사용자 태그",
    "create_share_album": "공유 앨범 만들기",
    "search": "사용자로 사진 필터링",
    "only_my_photo": "내 사진만",
    "new_favorite": "새 즐겨찾기 앨범을 만들고 추가",
    "add_result": "{{name}}에 추가했습니다",
    "add_favorite_result": "\"{{name}}\" 즐겨찾기에 추가했습니다",
    "change_favorite": "즐겨찾기 변경",
    "tagged_users": "태그된 사용자",
    "add_user_not_candidate": "후보가 아닌 사용자 추가",
    "select_tag_user_title": "태그할 사용자 선택",
    "not_registered": "미등록 Metamory 사용자",
    "share_success": "사진을 공유했습니다",
    "share_error": "사진 공유에 실패했습니다",
    "share_not_supported": "브라우저가 사진 공유를 지원하지 않습니다",
    "share_prepared": "사진 준비가 완료되었습니다. 다시 탭해서 공유해 주세요",
    "add_users_from_edit": "\"편집\"에서 사용자 추가",
    "no_tagged_users": "태그된 사용자가 없습니다",
    "users_in_instance": "인스턴스 내 사용자",
    "take_photo_with_others_or_enable_log": "다른 사용자와 함께 있는 인스턴스에서 사진을 찍거나 로그 파일 출력을 활성화해 주세요",
    "install_sync_tool": "사진 동기화 도구 설치",
    "auto_sync_users": "을(를) 사용하여 사진 속 사용자를 자동으로 동기화",
    "all_users_tagged": "모든 사용자가 태그되었습니다"
  },
  "myphoto_tutorial": {
    "title": "Metamory 사진 동기화 도구를 설치하세요!",
    "description": "사진 동기화 도구로 할 수 있는 것",
    "li1": "사진 자동 업로드",
    "li2": "사진 속 사용자 자동 연결",
    "li3": "월드 정보 자동 가져오기",
    "li4": "플레이 시간에 따른 날짜 판정",
    "download": "Metamory 사진 동기화 도구 다운로드",
    "upload": "사진 동기화 도구를 설치하지 않고 사진 업로드",
    "tutorial_link_text": "사진 동기화 도구의 설치, 실행, 종료 방법은",
    "tutorial_link": "튜토리얼",
    "tutorial_link_suffix": "을(를) 참고해 주세요",
    "download_now": "지금 다운로드"
  },
  "reaction_selector": {
    "search_no_results_2": "해당 리액션을 찾을 수 없습니다",
    "pick": "리액션을 선택하세요...",
    "frequent": "자주 사용"
  },
  "home": {
    "main": "메인",
    "my_photos": "내 사진",
    "vket": "Vket 2025 Summer",
    "new_photos_available": "새 사진 {{count}}장이 있습니다",
    "refresh": "새로고침",
    "storage_warning": "저장 공간이 부족합니다!"
  },
  "tutorial": {
    "title": "Metamory에 오신 것을 환영합니다!",
    "description": "Metamory를 더 잘 활용할 수 있도록, 먼저 몇 가지를 완료해 봅시다!",
    "profile_title": "프로필을 완성하세요",
    "profile_description": "프로필에 사진, 자기소개, 다른 서비스의 계정 정보를 추가하면 다른 사용자가 더 쉽게 찾을 수 있습니다!",
    "share_title": "공유 앨범 만들기",
    "share_description": "공유 앨범을 만들어 내가 찍은 사진을 다른 사용자에게 보여주고, 다른 사용자에게 내 사진을 공유받아 보세요!",
    "pc_client_title": "사진 동기화 도구 설치",
    "pc_client_description": "사진 동기화 도구를 사용하면 사진을 옮기는 것을 잊거나, 이 사람이 누구인지, 어디서 찍었는지 고민할 필요가 없습니다!"
  },
  "favorite": {
    "create_list": "새 즐겨찾기 목록 만들기",
    "special_favorite_name": "즐겨찾기",
    "no_title_favorite": "제목 없는 즐겨찾기",
    "no_photos_title": "즐겨찾기 사진이 없습니다",
    "no_photos_description": "사진을 즐겨찾기에 추가하고 추억을 돌아보세요",
    "edit_favorite": "즐겨찾기 편집",
    "delete_favorite_confirm": "이 즐겨찾기 목록을 삭제하시겠습니까?"
  },
  "notification": {
    "no_notification": "알림이 없습니다",
    "no_notification_description": "받은 알림이 여기에 표시됩니다",
    "no_invitation": "초대가 없습니다",
    "no_invitation_description": "공유 앨범 초대가 여기에 표시됩니다",
    "share_album_append": "{{num}}장의 사진이 추가되었습니다",
    "share_album_invitation": "{{name}}에 초대되었습니다",
    "share_album_owner_transferred": "이제 {{name}}의 소유자입니다",
    "share_album_invitation_accept": "수락",
    "invitation_accepted": "초대를 수락했습니다",
    "joined_album": "{{albumName}}에 참여했습니다"
  },
  "album": {
    "create_album": "앨범 만들기",
    "no_title_album": "제목 없는 앨범",
    "number_of_photos": "{{num}}장의 사진",
    "add_photo": "사진 추가",
    "invitation_album": "초대 앨범",
    "get_link": "링크 가져오기",
    "no_photos": "사진이 없습니다",
    "album_no_photo": "앨범에 사진이 없습니다",
    "album_no_photo_description": "이 앨범에 사진을 추가해 추억을 공유해 보세요.",
    "delete_album_success": "앨범을 삭제했습니다",
    "delete_album_confirm": "이 앨범을 삭제하시겠습니까?",
    "confirm_change_share": "이 앨범을 공유하시겠습니까?\n(MyAlbum으로 되돌릴 수 없습니다)"
  },
  "share": {
    "not_found_title": "앨범을 찾을 수 없습니다",
    "not_found_description": "앨범이 삭제되었거나 URL이 올바르지 않을 수 있습니다.",
    "back_to_share_list": "공유 앨범 목록으로 돌아가기",
    "empty_shares_title": "공유 앨범을 만들어 모두와 사진을 공유해 보세요!",
    "empty_shares_description": "공유 앨범을 만들고 사진을 추가해 다른 사용자와 사진을 공유하거나, 다른 사용자에게 내 사진을 공유받아 보세요!",
    "create_share_album": "공유 앨범 만들기",
    "share_range": "공유 범위",
    "share_range_description": "앨범을 누구와 공유할지 선택할 수 있습니다",
    "invite_only": "소유자만 초대 가능",
    "invite_only_description": "내가 앨범에 초대한 사용자만 참여할 수 있습니다",
    "invite_plus": "누구나 초대 가능",
    "invite_plus_description": "앨범에 초대한 사용자는 다른 사용자도 앨범에 초대할 수 있습니다",
    "public": "공개",
    "public_description": "링크를 아는 누구나 볼 수 있습니다",
    "public_lock": "공개(비밀번호 잠금)",
    "public_lock_description": "링크와 비밀번호를 아는 누구나 볼 수 있습니다",
    "invite_only_public_view": "공개(소유자만 편집자 초대 가능)",
    "invite_only_public_view_description": "멤버 관리는 초대 전용이지만, 링크를 아는 누구나 보고 리액션할 수 있습니다",
    "invite_plus_public_view": "공개(편집자가 편집자 초대 가능)",
    "invite_plus_public_view_description": "초대받은 사용자는 다른 사용자를 초대할 수 있고, 링크를 아는 누구나 보고 리액션할 수 있습니다",
    "member_list": "멤버 목록",
    "leave_share_album": "공유 앨범 나가기",
    "leave_share_album_confirm": "이 공유 앨범에서 나가시겠습니까?",
    "leave_share_album_success": "공유 앨범에서 나갔습니다",
    "edit_album": "앨범 편집",
    "delete_album": "앨범 삭제",
    "approval_awaiting_list": "승인 대기 목록",
    "album_login_required": "이 앨범을 보고 편집하려면\nMetamory에 로그인해야 합니다",
    "approval_awaiting_users": "승인 대기 중인 사용자",
    "approval_awaiting_empty_title": "승인 대기 중인 사용자가 없습니다",
    "approval_awaiting_empty_description": "현재 승인 대기 중인 사용자가 없습니다.\n새 참여 요청이 여기에 표시됩니다.",
    "invitation_users": "초대된 사용자",
    "invitation_users_list": "초대된 사용자 목록",
    "invitation_empty_title": "초대된 사용자가 없습니다",
    "invitation_empty_description": "현재 초대된 사용자가 없습니다.\n초대된 사용자가 여기에 표시됩니다.",
    "invitation_canceled": "초대를 취소했습니다",
    "cancel_invitation_confirm": "이 사용자의 초대를 삭제하시겠습니까?\n(앨범에 참여하려면 다시 초대해야 합니다)",
    "cancel_invitation_button": "초대 삭제",
    "auto_approval": "참여 신청 자동 승인",
    "auto_approval_description": "ON이면 앨범 참여 요청(보기 및 편집 권한 포함)이 자동으로 승인됩니다.\nOFF이면 앨범의 \"승인 대기 사용자 목록\"에 등록됩니다",
    "share_type_change_warning_title": "공유 설정 변경 확인",
    "warning_public_to_private": "초대 전용으로 변경하면 기존 접근 권한이 제한됩니다.",
    "warning_private_to_public": "공개로 변경하면 더 많은 사람이 접근할 수 있게 됩니다.",
    "warning_invite_permission_change": "멤버 초대 권한이 변경됩니다.",
    "confirm_change": "변경 확인",
    "change_owner": "앨범 소유자 변경",
    "change_owner_confirm": "앨범 소유자를 변경하면 더 이상 앨범을 설정할 수 없습니다",
    "change_owner_button": "소유자 변경",
    "change_owner_success": "앨범 소유자를 변경했습니다",
    "select_owner_empty_title": "소유권을 변경할 수 있는 멤버가 없습니다",
    "select_owner_empty_description": "소유자를 변경하려면 먼저 앨범에 멤버를 초대해 주세요.\n멤버가 없으면 소유권을 변경할 수 없습니다.",
    "add_users_title": "사용자 초대",
    "add_users_empty_title": "사용자 검색",
    "add_users_empty_description": "위 검색창에 사용자 이름 또는 ID를 입력하여\n초대할 사용자를 찾아보세요.",
    "join_request_message": "이 앨범을 보고 편집하려면 참여 요청을 보내야 합니다",
    "request_to_join": "참여 요청",
    "join_request_success": "참여 요청을 보냈습니다",
    "join_auto_approved": "앨범에 참여했습니다",
    "users_approved": "사용자를 승인했습니다",
    "invite_users": "사용자 초대",
    "invited_users": "초대된 사용자",
    "cancel_invitation": "초대 취소",
    "invited_by": "{{name}}님이 초대함",
    "accept_invitation": "수락",
    "decline_invitation": "거절",
    "user_invited": "사용자를 초대했습니다",
    "viewing_password": "보기 비밀번호",
    "set_viewing_password": "보기 비밀번호 설정",
    "set_viewing_password_success": "보기 비밀번호를 설정했습니다",
    "enter_password": "이 앨범을 보고 편집하려면 비밀번호가 필요합니다",
    "view": "보기",
    "password_error": "비밀번호 오류",
    "member": "멤버",
    "kick_from_album": "앨범에서 내보내기",
    "kick_success": "앨범에서 내보냈습니다",
    "delete_share_confirm": "이 앨범을 삭제하시겠습니까? (삭제하면 다른 사용자가 앨범을 볼 수 없습니다)",
    "leave_share_confirm": "이 앨범에서 나가시겠습니까?\n(앨범에서 나가면 더 이상 앨범을 볼 수 없습니다)",
    "leave": "나가기",
    "link_copied": "공유 링크를 복사했습니다",
    "login_dialog": "이 앨범을 보거나 편집하려면 Metamory에 로그인해야 합니다.",
    "encourage_register_message": "Metamory에 가입하고\n친구와 앨범을 공유해 보세요",
    "start_metamory": "Metamory 시작하기",
    "is_sensitive_label": "민감한 앨범",
    "is_sensitive_description": "활성화하면 18세 미만의 사용자는 앨범을 볼 수 없게 됩니다"
  },
  "modal": {
    "logout_message": "로그아웃하시겠습니까?",
    "confirm_leave_page": "이 페이지를 떠나시겠습니까?",
    "leave_page": "페이지 떠나기",
    "confirm_discard_edit": "편집 내용이 저장되지 않았습니다. 취소하고 닫으시겠습니까?",
    "discard_edit": "취소하고 닫기",
    "login_confirm": "로그인 페이지로 이동하려고 합니다.\n계속하려면 \"이동\"을 눌러 주세요."
  },
  "popup_menu": {
    "choice_favorite": "즐겨찾기 선택",
    "choice_reaction": "리액션 추가",
    "reaction_detail": "리액션 상세",
    "photo_detail": "사진 상세",
    "create_myalbum": "새 MyAlbum 만들기",
    "choice_photo_append_type": "사진 추가 유형 선택",
    "choice_photo_append_myalbum": "내 앨범 추가 선택",
    "choice_photo_append_share": "공유 앨범 추가 선택",
    "choice_photo_append_public_album": "공개 앨범 추가 선택",
    "choice_photo_append_public_lock_album": "공개 앨범(비밀번호 잠금) 추가 선택",
    "choice_photo_append_favorite": "즐겨찾기 추가 선택",
    "choice_photo_append_dm": "DM 추가 선택"
  },
  "address_book": {
    "add_user": "새 사용자 추가",
    "empty_user_title": "주소록에 사용자가 없습니다",
    "empty_user_description": "사용자를 주소록에 추가해 사진을 공유해 보세요",
    "create_group": "그룹 만들기",
    "empty_group_title": "생성된 그룹이 없습니다",
    "empty_group_description": "사용자를 그룹에 등록해 더 원활하게 공유해 보세요!",
    "book_user": "주소록에 사용자 추가"
  },
  "user": {
    "add_book": "등록",
    "add_book_success": "등록했습니다",
    "in_book": "등록됨",
    "add_group": "그룹 추가",
    "outbook_dialog_message": "이 사용자의 등록을 해제하시겠습니까?\n(나중에 다시 등록할 수 있습니다)",
    "out_book": "등록 해제",
    "mute_user": "이 사용자 음소거",
    "unmute_user": "이 사용자 음소거 해제",
    "mute_dialog_message": "이 사용자를 음소거하시겠습니까?\n(음소거한 사용자의 사진은 볼 수 없게 됩니다)",
    "mute": "음소거",
    "mute_warning": "이 사용자를 음소거하고 있으므로, 이 사용자가 추가한 사진이나 리액션을 볼 수 없습니다",
    "muted_user": "사용자를 음소거했습니다",
    "report_user": "사용자 신고",
    "report_this_user": "이 사용자를 신고",
    "report_dialog_message": "가이드라인을 위반하는 내용을 선택해 주세요",
    "report_reason_icon": "부적절한 아이콘 이미지",
    "report_reason_icon_detail": "가이드라인을 위반하는 사진을 아이콘으로 사용하고 있는 경우 등",
    "report_reason_name": "부적절한 사용자 이름·ID",
    "report_reason_name_detail": "사용자 이름이나 ID에 가이드라인을 위반하는 단어가 포함된 경우 등",
    "report_reason_description": "부적절한 자기소개문",
    "report_reason_description_detail": "자기소개문에 가이드라인을 위반하는 단어가 포함된 경우 등",
    "report_reason_other": "기타",
    "report_reason_other_detail": "위에 해당하지 않는 가이드라인 위반 콘텐츠",
    "reported_user": "사용자를 신고했습니다",
    "report_error_user_not_found": "사용자를 찾을 수 없습니다",
    "unmuted_user": "사용자 음소거를 해제했습니다",
    "add_group_success": "'{{name}}' 그룹에 추가했습니다",
    "search_no_result": "검색 조건과 일치하는 결과가 없습니다",
    "search_no_result_description": "정확한 사용자 이름을 입력하거나 사용자 ID로 검색하면 친구를 더 쉽게 찾을 수 있습니다",
    "search_friend_not_found": "친구를 찾을 수 없다면 어떻게 하나요?",
    "search_friend_not_found_description": "정확한 사용자 이름을 입력하거나 사용자 ID로 검색하면 친구를 더 쉽게 찾을 수 있습니다!",
    "frozen_account": "이 계정은 <l>Metamory 이용약관</l>을 위반하여 동결되었습니다.",
    "frozen_user_name": "동결된 사용자"
  },
  "profile": {
    "edit_profile": "프로필 편집",
    "edit_profile_success": "프로필을 편집했습니다",
    "user_id": "사용자 ID",
    "user_id_char_error": "영숫자를 입력해 주세요",
    "user_name": "사용자 이름",
    "user_description": "자기소개",
    "collaboration_other_service": "다른 서비스와의 연동",
    "vrchat_input_hint": "VRChat 사용자 페이지 URL이 자동으로 변환됩니다(예: https://vrchat.com/home/user/usr_XXXXX)",
    "twitter_input_hint": "X(Twitter) 사용자 페이지 URL이 자동으로 변환됩니다(예: https://x.com/XXXXX)",
    "exist_metamory_id": "이 ID는 이미 존재합니다"
  },
  "group": {
    "no_title_group": "제목 없는 그룹",
    "edit_group": "그룹 편집",
    "delete_group": "그룹 삭제",
    "delete_group_confirm": "이 그룹을 삭제하시겠습니까?",
    "users_length": "{{num}}명의 사용자가 이 그룹에 속해 있습니다",
    "users_0": "이 그룹에 속한 사용자가 없습니다",
    "add_user": "그룹에 사용자 추가",
    "add_user_min": "사용자 추가",
    "no_user": "이 그룹에 사용자가 없습니다",
    "no_user_description": "이 그룹에 사용자를 추가해 사진을 공유해 보세요",
    "san": "{{name}}",
    "comma": ","
  },
  "dm": {
    "create_dm": "DM 만들기",
    "no_dms": "DM이 없습니다",
    "no_dms_description": "친구를 찾아 DM을 보내 보세요!",
    "no_photos_title": "DM에 사진이 없습니다",
    "no_photos_description": "이 DM에 사진을 추가해 추억을 공유해 보세요",
    "dm_title": "{{name}}님의 DM",
    "append_photos": "{{name}}님의 DM에 사진을 추가했습니다",
    "search_user": "사용자 검색",
    "search_user_description": "사용자를 검색해 DM을 만들어 보세요"
  },
  "auth": {
    "current_password": "현재 비밀번호",
    "new_password": "새 비밀번호",
    "confirm_new_password": "새 비밀번호 확인",
    "update_password": "비밀번호 업데이트",
    "passwords_must_match": "비밀번호가 일치하지 않습니다",
    "attempt_limit_exceeded": "시도 횟수 제한을 초과했습니다. 잠시 후 다시 시도해 주세요",
    "password_too_long": "비밀번호는 256자 이하여야 합니다",
    "password_edge_whitespace": "비밀번호의 처음과 끝에는 공백을 사용할 수 없습니다",
    "password_policy": "{{num}}자 이상",
    "show_password": "{{field}} 표시",
    "hide_password": "{{field}} 숨기기",
    "invalid_credentials": "이메일 주소 또는 비밀번호가 올바르지 않습니다",
    "incorrect_current_password": "현재 비밀번호가 올바르지 않습니다",
    "session_expired": "로그인이 만료되었습니다. 다시 로그인해 주세요",
    "invalid_code": "인증 코드가 올바르지 않거나 만료되었습니다",
    "network_error": "연결에 실패했습니다. 연결을 확인하고 다시 시도해 주세요",
    "unexpected_error": "처리에 실패했습니다. 다시 시도해 주세요",
    "username_exists": "이미 등록된 이메일 주소입니다",
    "invalid_password": "비밀번호 조건을 충족하지 않습니다",
    "sign_in": "로그인",
    "sign_up": "회원가입",
    "forgot_password": "비밀번호를 잊으셨나요?",
    "back_to_sign_in": "로그인으로 돌아가기",
    "create_account": "계정 만들기",
    "confirm_sign_up_title": "이메일 주소 확인",
    "confirm_sign_up_description": "{{email}}(으)로 보낸 확인 코드를 입력하세요",
    "confirmation_code": "확인 코드",
    "confirm": "확인",
    "resend_code": "코드 재전송",
    "code_resent": "확인 코드를 다시 보냈습니다",
    "reset_password_title": "비밀번호 재설정",
    "reset_password_description": "등록된 이메일 주소로 확인 코드를 보냅니다",
    "send_code": "코드 보내기",
    "reset_password_code_description": "{{email}}(으)로 보낸 확인 코드와 새 비밀번호를 입력하세요",
    "reset_password": "비밀번호 재설정",
    "password_reset_done": "비밀번호를 재설정했습니다. 새 비밀번호로 로그인하세요",
    "sign_up_confirmed": "가입이 완료되었습니다. 로그인하세요",
    "already_confirmed": "이미 확인된 이메일 주소입니다. 로그인하세요",
    "user_not_found": "이 이메일 주소로 등록된 계정을 찾을 수 없습니다",
    "unverified_reset": "이 계정은 확인이 완료되지 않아 비밀번호를 재설정할 수 없습니다. 로그인하면 확인 코드를 다시 받을 수 있습니다",
    "contact_admin": "이 계정은 비밀번호 설정이 필요합니다. 도움말 및 피드백에서 문의해 주세요",
    "continue": "다음",
    "checking_passkey": "패스키를 확인하는 중…",
    "retry_with_passkey": "패스키로 다시 시도",
    "use_different_email": "다른 이메일 사용",
    "password_step_hint": "비밀번호를 입력해 로그인하세요",
    "passkey_canceled_hint": "패스키 로그인이 취소되었습니다. 비밀번호를 입력하거나 패스키로 다시 시도해 주세요",
    "passkey_failed_hint": "패스키로 로그인하지 못했습니다. 비밀번호를 입력하거나 패스키로 다시 시도해 주세요"
  },
  "setting": {
    "profile_title": "프로필 설정",
    "profile_description": "계정 이메일 주소, 비밀번호 등을 설정할 수 있습니다",
    "notification_title": "알림 설정",
    "notification_description": "Metamory가 보내는 알림을 관리합니다",
    "display_and_accessibility_title": "표시 및 접근성 설정",
    "display_and_accessibility_description": "화면 표시와 언어를 설정할 수 있습니다",
    "ui_theme_title": "UI 테마",
    "ui_theme_description": "UI 테마를 설정할 수 있습니다",
    "color_mode_system": "시스템 설정에 따라",
    "color_mode_light": "라이트 모드",
    "color_mode_dark": "다크 모드",
    "client_application_title": "사진 동기화 도구",
    "client_application_description": "사진 동기화 도구를 다운로드하고 설정할 수 있습니다",
    "language_title": "언어",
    "language_description": "표시 언어를 선택할 수 있습니다",
    "language_japanese": "日本語",
    "language_english": "English",
    "language_korean": "한국어",
    "account_setting": "계정 설정",
    "set_new_password": "새 비밀번호 설정",
    "delete_account": "계정 삭제",
    "delete_account_confirm": "계정을 삭제하시겠습니까?",
    "change_email": "이메일 주소 변경",
    "change_email_description": "계정에 연결된 이메일 주소를 변경합니다",
    "current_email": "현재 이메일 주소",
    "new_email": "새 이메일 주소",
    "confirm_code_title": "인증 코드 입력",
    "verification_code": "인증 코드",
    "confirmation_email_sent": "확인 이메일을 보냈습니다",
    "change_password": "비밀번호 변경",
    "change_password_description": "계정에 연결된 비밀번호를 변경합니다",
    "passkey_description": "지문, 얼굴 인식, 화면 잠금으로 로그인합니다",
    "password_updated": "비밀번호를 업데이트했습니다",
    "metamory_id": "Metamory ID",
    "your_metamory_id": "내 Metamory ID",
    "delete_account_input_confirm": "계정을 삭제하려면 확인을 위해 Metamory ID를 입력해 주세요",
    "notification": {
      "share_reaction": "공유 앨범 사진에 대한 리액션",
      "share_add_photo": "공유 앨범에 사진 추가",
      "share_name_change": "공유 앨범 이름 변경",
      "share_type_change": "공유 앨범 유형 변경",
      "dm_reaction": "DM 사진에 대한 리액션",
      "dm_receive": "DM 수신"
    },
    "client_application": {
      "title": "사진 동기화 도구 설정",
      "tutorial_instruction": "사진 동기화 도구의 설치, 실행, 종료 방법은 아래 튜토리얼을 참고해 주세요",
      "tutorial_button": "사진 동기화 도구 튜토리얼",
      "installed_devices": "사진 동기화 도구를 설치한 기기 목록",
      "installed_devices_description": "현재 동기화에 사용 중인 기기 목록",
      "device_disconnect": "기기 연결 해제",
      "device_disconnect_description": "연결을 해제한 기기를 다시 연결하려면, 연결하려는 기기의 사진 동기화 도구를 열어 다시 설정해 주세요",
      "disconnect": "연결 해제",
      "disconnect_confirm": "이 기기의 연결을 해제하시겠습니까? (연결 해제 시 자동 업로드도 중지됩니다)",
      "client_application_download": "사진 동기화 도구 다운로드",
      "client_application_download_description_mobile": "사진 동기화 도구를 다운로드하면 기기로 촬영한 사진을 Metamory에 자동으로 업로드할 수 있습니다",
      "client_application_download_description_pc": "사진 동기화 도구를 다운로드하면 기기로 촬영한 사진을 Metamory에 자동으로 업로드할 수 있습니다",
      "download_pwa": "웹 앱 다운로드",
      "download_pwa_description": "(Google Chrome 사용 시)\n\"추가 기능\" 메뉴에서 \"홈 화면에 추가\"를 누르면 스마트폰에 Metamory를 추가할 수 있습니다"
    },
    "privacy_and_safety_title": "개인정보 및 안전",
    "privacy_and_safety_description": "음소거한 사용자 등을 관리합니다",
    "muted_users_title": "음소거한 사용자",
    "muted_users_description": "음소거하고 있는 사용자 목록을 볼 수 있습니다",
    "muted_users_header": "음소거한 사용자",
    "muted_users_empty_title": "음소거한 사용자가 없습니다",
    "muted_users_empty_description": "음소거한 사용자는 여기에 표시됩니다",
    "unmute_dialog_message": "이 사용자의 음소거를 해제하시겠습니까?",
    "unmute_button": "음소거 해제",
    "unmuted_user_success": "음소거를 해제했습니다"
  },
  "welcome": {
    "welcome": "Metamory에 오신 것을 환영합니다!",
    "description": "먼저 프로필을 설정해\n친구들이 나를 쉽게 찾을 수 있게 해보세요!",
    "set_profile": "프로필 설정",
    "sign_out_description": "잘못된 계정으로 등록했다면 여기를 클릭하세요",
    "sign_out": "로그아웃"
  },
  "help": {
    "how_to_use_title": "Metamory 사용 방법",
    "how_to_use_description": "Metamory의 각 기능 사용 방법을 확인하려면 여기를 클릭하세요",
    "populer_question_title": "자주 묻는 질문",
    "populer_question_description": "자주 묻는 질문에 대한 답변을 Q&A 형식으로 확인할 수 있습니다",
    "feedback_title": "피드백",
    "feedback_description": "버그 신고나 기능 개선 의견은 여기를 통해 보내 주세요(Metamory 공식 Discord 서버로 이동합니다)",
    "discord_title": "공식 Discord 커뮤니티",
    "discord_description": "Metamory 사용자 및 운영진과 소통하고 싶다면 여기를 클릭하세요!",
    "go_out_site_confirm": "사이트를 나가시겠습니까?",
    "go": "이동",
    "go_discord_confirm": "Metamory 공식 서버(Discord)로 이동합니다",
    "go_discord": "이동",
    "privacy_policy_and_terms_description": "Metamory 이용약관 및 개인정보처리방침에 대해 자세히 알아보세요"
  },
  "trash": {
    "moved_to_trash": "사진을 휴지통으로 이동했습니다",
    "open_trash": "휴지통 열기",
    "empty_trash": "휴지통 비우기",
    "empty_trash_description": "사진을 삭제하면 30일 동안 휴지통에 보관됩니다",
    "restore": "MyPhoto로 복원",
    "delete_from_trash": "완전히 삭제",
    "delete_all_from_trash": "휴지통에서 모두 완전히 삭제",
    "delete_from_trash_confirm": "{{num}}장의 사진을 삭제하시겠습니까?\n(사진은 Metamory에서 완전히 삭제됩니다)",
    "deleted_from_trash": "휴지통에서 삭제했습니다",
    "deleting_in_background": "백그라운드에서 삭제 중입니다",
    "processing_in_background": "백그라운드에서 처리 중입니다",
    "restored_from_trash": "휴지통에서 복원했습니다",
    "trashed_on": "{{date}}에 삭제"
  },
  "search": {
    "user": "{{name}}님의 사진",
    "owner": "촬영자",
    "in_users": "사진 속 사용자"
  },
  "accept_rules": {
    "mobile_title": "이용약관 개정",
    "dialog_title": "새 개인정보처리방침",
    "dialog_description": "Metamory의 개인정보처리방침이 개정되었습니다. 자세한 내용은 <l>이용약관</l>을 확인해 주세요",
    "accept": "동의하고 계속"
  },
  "error": {
    "occurred": "오류가 발생했습니다",
    "occurred_message": "죄송합니다.\n브라우저를 새로고침한 뒤 다시 시도해 주세요.\n스마트폰, Chrome 등에 설치한 경우 Metamory를 다시 시작해 주세요.\n이 화면이 반복해서 표시되면 피드백을 보내 주세요.",
    "occurred_with_trace": "오류가 발생했습니다 (Trace ID: {{traceId}})",
    "text_length_over": "문자 수가 {{limit}}자를 초과했습니다(현재 {{num}}자)",
    "text_bytes_over": "바이트 수가 {{limit}}바이트를 초과했습니다(현재 {{num}}바이트)",
    "text_length_fewer": "문자 수가 {{limit}}자보다 적습니다(현재 {{num}}자)",
    "404_title": "페이지를 찾을 수 없습니다",
    "404_description": "열심히 찾아봤지만 요청하신 페이지를 찾을 수 없었습니다",
    "general": "오류가 발생했습니다",
    "update": "업데이트에 실패했습니다",
    "update_with_trace": "업데이트에 실패했습니다 (Trace ID: {{traceId}})",
    "analysis_info": "오류 분석 정보",
    "photo_not_found": "사진을 찾을 수 없습니다",
    "photo_not_found_with_trace": "사진을 찾을 수 없습니다 (Trace ID: {{traceId}})",
    "fetch": "데이터 가져오기에 실패했습니다",
    "fetch_with_trace": "데이터 가져오기에 실패했습니다 (Trace ID: {{traceId}})",
    "fetch_limit_stop": "동일한 서버 요청이 한 번에 너무 많이 발생해 중지했습니다",
    "fetch_data_with_trace": "데이터 가져오기에 실패했습니다 (Trace ID: {{traceId}})",
    "fetch_me": "사용자 데이터 가져오기에 실패했습니다",
    "fetch_me_with_trace": "사용자 데이터 가져오기에 실패했습니다 (Trace ID: {{traceId}})",
    "fetch_notifications": "알림 데이터 가져오기에 실패했습니다",
    "fetch_notifications_with_trace": "알림 데이터 가져오기에 실패했습니다 (Trace ID: {{traceId}})",
    "create": "생성에 실패했습니다",
    "create_with_trace": "생성에 실패했습니다 (Trace ID: {{traceId}})",
    "delete": "삭제에 실패했습니다",
    "delete_with_trace": "삭제에 실패했습니다 (Trace ID: {{traceId}})",
    "upload": "업로드에 실패했습니다"
  },
  "photo_editor": {
    "title": "사진 편집",
    "menu_label": "사진 편집",
    "upload_success": "편집한 사진을 저장했습니다",
    "crop_free": "자유",
    "crop_full": "전체",
    "aspect_ratio_label": "비율",
    "rotate_label": "회전",
    "rotate_left": "왼쪽으로 회전",
    "rotate_right": "오른쪽으로 회전",
    "share_to_x": "X에 게시",
    "share_to_x_copied": "이미지가 복사되었습니다.\n아래 버튼으로 X 게시 화면을 열고 붙여넣어 게시하세요.",
    "share_to_x_open": "X 열기",
    "share_to_x_error": "클립보드에 이미지 복사 실패"
  },
  "photo_sticker": {
    "title": "스티커 만들기",
    "menu_label": "스티커 만들기",
    "coach_mark": "스티커 기능을 사용해 보세요!",
    "select_photo": {
      "leave_confirm": "스티커로 만들 사진 선택을 그만둘까요?",
      "title": "스티커로 만들 사진 선택",
      "guide_title": "스티커로 만들 사진을 탭하세요"
    },
    "settings_tabs": "스티커 설정",
    "border_tab": "테두리",
    "text_tab": "문자",
    "watermark_tab": "워터마크",
    "preview": "스티커 미리보기",
    "border_size_label": "테두리",
    "border_color_label": "테두리 색상",
    "text_input_label": "문자",
    "text_font_label": "글꼴",
    "text_font_name_default": "기본",
    "text_font_group_standard": "기본",
    "text_font_group_japanese": "일본어",
    "text_font_group_korean": "한국어",
    "text_font_group_latin": "영문",
    "text_font_loading": "글꼴 불러오는 중",
    "text_font_load_error": "글꼴을 불러오지 못했습니다. 네트워크 연결을 확인해 주세요.",
    "prepare_error": "이미지를 불러오지 못했습니다. 다시 시도해 주세요.",
    "text_size_label": "문자 크기",
    "text_italic_label": "기울임꼴",
    "text_placement_label": "겹침",
    "text_behind": "뒤",
    "text_front": "앞",
    "text_color_label": "문자 색상",
    "text_background_label": "배경",
    "text_background_none": "없음",
    "text_background_outline": "테두리",
    "text_background_bubble": "말풍선",
    "text_outline_color_label": "문자 테두리",
    "text_outline_color_short": "문자 테두리 색",
    "bubble_color_label": "말풍선 색상",
    "bubble_border_color_label": "말풍선 테두리 색상",
    "bubble_color_short": "채우기 색",
    "bubble_border_color_short": "말풍선 테두리 색",
    "bubble_border_none": "말풍선 테두리 없음",
    "bubble_tail_label": "꼬리 방향",
    "bubble_tail_up_left": "위·왼쪽",
    "bubble_tail_up": "위",
    "bubble_tail_up_right": "위·오른쪽",
    "bubble_tail_right_up": "오른쪽·위",
    "bubble_tail_right": "오른쪽",
    "bubble_tail_right_down": "오른쪽·아래",
    "bubble_tail_down_right": "아래·오른쪽",
    "bubble_tail_down": "아래",
    "bubble_tail_down_left": "아래·왼쪽",
    "bubble_tail_left_down": "왼쪽·아래",
    "bubble_tail_left": "왼쪽",
    "bubble_tail_left_up": "왼쪽·위",
    "watermark_label": "워터마크",
    "upload_to_vrchat": "VRChat에 업로드",
    "vrchat_upload_description": "VRChat 스티커용으로 {{max}}px에 맞춘 PNG를 다운로드할 수 있습니다.\n다운로드 후 VRChat 스티커 업로드 화면에서 이미지를 선택해 주세요.",
    "download_for_vrchat": "VRChat용 다운로드",
    "open_vrchat_upload": "업로드 화면 열기",
    "download": "다운로드",
    "remaining": "{{count}}회 남음",
    "remaining_exhausted": "다음 주에",
    "quota_exceeded": "이번 주 스티커 생성 한도에 도달했어요. 다음 주에 다시 이용할 수 있어요",
    "confirm_close_without_export": "이 화면을 닫으면 편집 중인 스티커가 저장되지 않으며, 스티커 생성 횟수도 복구되지 않습니다. 스티커 만들기를 중단하시겠습니까?",
    "close_without_export": "중단"
  },
  "campaign": {
    "vket2025summer_applied": "캠페인이 적용되었습니다\n최대 사진 저장 한도가 2000장으로 증가했습니다",
    "applied": "캠페인이 적용되었습니다!"
  },
  "pr": {
    "vket": {
      "post_timeline": "Vket 타임라인에 게시",
      "cancel_post_timeline": "게시 취소",
      "already_post_timeline": "이미 Vket 타임라인에 게시됨",
      "success_post_timeline": "Vket 타임라인에 게시했습니다",
      "error_post_timeline": "게시할 수 없습니다. 다시 시도해 주세요",
      "already_posted": "이 사진은 이미 Vket 타임라인에 게시되었습니다",
      "no_world_info": "월드 정보가 없습니다. 사진 동기화 도구를 설치해 주세요",
      "not_world": "Vket 2025 Summer 월드가 아니면 게시할 수 없습니다"
    },
    "vket2025winter": {
      "start_metamory": "Metamory 시작하기",
      "benefit_timing_title": "혜택 지급 기간",
      "benefit_timing_date": "2026년 1월 말",
      "condition1_title": "【조건 1】Metamory 1,500장 혜택을 받는 방법",
      "condition1_step1": "Vket 2025 Winter에서 Grandmaster를 달성하세요",
      "condition1_step1_detail": "Grandmaster 달성 방법의 자세한 내용은",
      "condition1_step1_link": "여기",
      "condition1_step2": "아직 Metamory에 가입하지 않았다면",
      "condition1_step2_link": "여기",
      "condition1_step2_1": "에서 가입을 진행해 주세요",
      "condition1_step2_2": "Metamory 가입 후 PC 앱을 설치하고 로그인해 주세요",
      "condition1_step2_note": "※설치 또는 로그인할 수 없는 경우 아래 지원 페이지를 확인해 주세요",
      "condition1_step2_help": "Metamory 도움말 페이지",
      "condition1_step2_discord": "Metamory 사용자 커뮤니티 Discord",
      "condition1_step3": "이미 Metamory에 가입되어 있다면",
      "condition1_step3_detail": "별도의 작업이 필요 없습니다!",
      "condition1_step4": "절차 완료!",
      "condition1_step4_detail": "2026년 1월 말경 한도가 자동 반영됩니다",
      "condition2_title": "【조건 2】Metamory 2,000장 혜택을 받는 방법",
      "condition2_step1": "【조건 1】을 완료한 후 '공유 앨범'을 만드세요",
      "condition2_step1_detail": "홈 화면의 '공유 앨범' > '새 앨범 만들기'에서 앨범을 생성하고 공개해 주세요(앨범 유형은 상관없음)",
      "condition2_step2": "절차 완료!",
      "condition2_step2_detail": "2026년 1월 말경 한도가 자동 반영됩니다",
      "faq_title": "자주 묻는 질문",
      "faq_q1": "Q. 이미 Metamory에 가입했고 PC 앱도 설치 및 로그인한 상태라면, Grandmaster 달성 시 자동으로 1,500장을 받나요?",
      "faq_a1": "A. 네, 자동으로 1,500장을 받습니다!",
      "faq_a1_detail": "한도는 2026년 1월 말경 반영되므로 조금만 기다려 주세요",
      "faq_q2": "Q. Grandmaster 달성 후 Metamory에 가입하지 않았습니다. 혜택의 유효기간은 언제까지인가요?",
      "faq_a2": "A. 2026년 1월 18일까지입니다!",
      "faq_a2_detail": "유효기간 이후에는 혜택을 제공할 수 없으니 주의해 주세요",
      "faq_q3": "Q. 이전 Metamory 캠페인으로 이미 저장 한도가 1,000장 이상입니다. 추가 사진을 받을 수 있나요? (현재 2,000장이라면 3,500장이 되나요?)",
      "faq_a3": "A. 아니요, 추가 사진은 지급되지 않습니다...!",
      "faq_a3_detail": "현재 한도가 이미 2,000장이라면【조건 1】을 달성해도 1,500장으로 내려가지 않으니 안심해 주세요",
      "top_image_alt": "Vket 2025 Winter 상단 이미지",
      "middle_image_alt": "Vket 2025 Winter 메인 이미지"
    },
    "honda2026": {
      "post_timeline": "Honda Motanion 타임라인에 게시",
      "cancel_post_timeline": "게시 취소",
      "already_post_timeline": "이미 Honda Motanion 타임라인에 게시됨",
      "success_post_timeline": "Honda Motanion 타임라인에 게시했습니다",
      "error_post_timeline": "게시할 수 없습니다. 다시 시도해 주세요",
      "already_posted": "이 사진은 이미 Honda Motanion 타임라인에 게시되었습니다",
      "no_world_info": "월드 정보가 없습니다. 사진 동기화 도구를 설치해 주세요",
      "not_world": "Honda Motanion 월드가 아니면 게시할 수 없습니다"
    }
  },
  "about": {
    "sticker_tutorial": {
      "images": {
        "result": "글자와 테두리를 추가한 스티커 완성 예시",
        "create": "사진 뷰어 메뉴의 스티커 만들기 항목",
        "edit": "테두리와 문자 탭 및 테두리 조절 기능이 표시된 스티커 편집 화면"
      },
      "title": "사진으로 스티커를 만들어 보세요",
      "choose_photo": "내 사진에서 스티커 만들기",
      "back": "뒤로",
      "result": {
        "title": "완성된 스티커",
        "body": "사진의 피사체를 오려내고 글자와 테두리를 더해 나만의 스티커를 만들 수 있습니다."
      },
      "open": {
        "title": "1. 사진 열기",
        "body": "<photos>내 사진</photos>에서 사진을 엽니다.",
        "note": "내 사진에는 직접 업로드한 사진이 표시됩니다. 다른 사람의 사진으로는 스티커를 만들 수 없습니다."
      },
      "create": {
        "title": "2. 만들기 시작",
        "body": "사진 뷰어 오른쪽 위 메뉴(⋮)에서 “스티커 만들기”를 선택합니다.",
        "note": "스티커 생성에는 주간 한도가 있습니다. 한도에 도달하면 다음 주에 다시 만들 수 있습니다."
      },
      "edit": {
        "title": "3. 꾸미기",
        "body": "“테두리”에서 테두리를 조절하고 “문자”에서 글자를 추가합니다. 글꼴, 크기, 색상과 말풍선 배경을 선택할 수 있습니다."
      },
      "save": {
        "title": "4. 저장하고 사용하기",
        "body": "“다운로드”를 선택하면 이미지를 저장할 수 있습니다. VRChat 내에서 사용하려면 공유 아이콘에서 “VRChat에 업로드”를 열고 “VRChat용 다운로드”를 선택하세요. 다운로드한 스티커를 VRChat의 스티커 업로드 페이지에서 업로드해 주세요."
      }
    },
    "info": "안내",
    "view_old_info": "이전 안내 보기",
    "hide_old_info": "이전 안내 숨기기",
    "register_account": "가입하고 시작하기",
    "wish_openbeta_account": "Metamory에 로그인",
    "goto_metamory": "Metamory로 이동",
    "twitter_link": "Metamory 공식 X",
    "privacy_policy_description": "자세한 내용은 <l>개인정보처리방침 페이지</l>를 참고해 주세요.",
    "help_description": "사용법이나 계정 관리에 문제가 있다면 <l>도움말 페이지</l>를 확인해 주세요.",
    "privacy_policy_and_terms": "개인정보처리방침 및 이용약관",
    "child_safe_policy": "아동 안전 정책",
    "tradelaw": "특정상거래법에 따른 표기",
    "faq": {
      "faq": "자주 묻는 질문",
      "how_to_use": "Metamory 사용 방법",
      "contact": "문의"
    },
    "client_tutorial": {
      "title": "사진 동기화 도구 튜토리얼",
      "table_of_contents": "목차",
      "contents": {
        "download": "1. 다운로드",
        "install": "2. 설치",
        "confirm": "3. 실행 확인",
        "faq": "자주 묻는 질문"
      },
      "images": {
        "settings_screen": "설정 화면",
        "download_button": "다운로드 버튼",
        "download_file": "다운로드 파일",
        "windows_protection": "Windows 보호 화면",
        "signin_screen": "로그인 화면",
        "browser_auth_screen": "브라우저 인증 화면",
        "syncing_device": "동기화 중인 기기",
        "notification_area": "알림 영역",
        "dashboard": "대시보드"
      },
      "download": {
        "title": "1. 사진 동기화 도구 다운로드",
        "step1": "사이드 메뉴의 \"기타\"에서 \"설정\"을 열고, \"사진 동기화 도구\"를 클릭해 주세요.",
        "step2": "\"사진 동기화 도구 다운로드\" 버튼을 눌러 설치 프로그램을 다운로드해 주세요.",
        "step2_note": "사진 동기화 도구는 스마트폰에서 다운로드할 수 없습니다. PC에서 이용해 주세요.",
        "step3": "\"MetamoryClient_x64-setup.exe\"가 다운로드되었는지 확인해 주세요."
      },
      "install": {
        "title": "2. 사진 동기화 도구 설치",
        "step1": "방금 다운로드한 \"MetamoryClient_x64-setup.exe\"를 더블클릭하여 실행해 주세요.",
        "step1_note": "\"Windows에서 PC를 보호했습니다\"라는 메시지가 표시되면 \"추가 정보\"를 누른 뒤 오른쪽 아래의 \"실행\"을 클릭해 주세요.",
        "step3": "\"이 알 수 없는 게시자의 앱이 디바이스를 변경하도록 허용하시겠습니까?\"라고 표시되면 \"예\"를 선택해 주세요.",
        "step4": "\"설치 마법사가 완료되었습니다\"라는 메시지가 표시되면 설치 프로그램을 닫아도 됩니다.",
        "step5": "처음 실행할 때 다음과 같은 화면이 표시됩니다.",
        "step5b": "\"Metamory로 로그인\" 버튼을 클릭하면 브라우저가 자동으로 열리고 다음과 같은 화면이 표시됩니다.",
        "step5_email": "\"Email address\"에는 Metamory 계정을 만들 때 입력한 이메일 주소를, \"Password\"에는 Metamory 계정의 비밀번호를 입력해 주세요.",
        "step5_success": "\"Authentication successful! You can close this window.\"가 표시되면 인증이 완료된 것입니다. 페이지를 닫아도 됩니다."
      },
      "confirm": {
        "title": "3. 실행 확인 및 종료",
        "step1": "설치 과정이 완료되면 Metamory 사진 동기화 도구가 자동으로 실행되며, 이후에도 PC를 시작할 때마다 자동으로 실행되어 VRChat에서 촬영한 사진을 자동으로 동기화합니다.",
        "step1_note": "사진 동기화 도구 실행과 로그인 인증이 정상적으로 완료되면 Metamory의 \"설정\" -> \"사진 동기화 도구\"에서 동기화 중인 기기를 확인할 수 있습니다."
      },
      "faq": {
        "title": "자주 묻는 질문과 답변",
        "sync_issue": {
          "short_title": "자동 동기화 안 됨",
          "title": "사진 동기화 도구의 자동 동기화가 동작하지 않습니다",
          "step1": "알림 영역(작업 표시줄 오른쪽)에서 사진 동기화 도구가 실행 중인지 확인해 주세요.",
          "step2": "알림 영역의 사진 동기화 도구 아이콘을 클릭하여 \"대시보드\"를 열고, 왼쪽 아래를 확인하여 올바른 계정으로 로그인되어 있는지 확인해 주세요. 로그인되어 있지 않은 경우 다음과 같은 화면이 표시됩니다.",
          "step3": "알림 영역의 사진 동기화 도구 아이콘을 클릭하여 \"대시보드\"를 열고, \"자동 업로드\" 스위치가 켜져 있는지 확인해 주세요."
        },
        "world_info": {
          "short_title": "월드 정보 미동기화",
          "title": "자동 업로드된 사진에 월드 정보와 사용자 정보가 동기화되지 않습니다",
          "step1": "사진이 업로드되었더라도 월드 및 사용자 정보는 아직 동기화되지 않았을 수 있습니다. 몇 분 정도 기다린 뒤 다시 시도해 주세요.",
          "step2": "VRChat 설정에서 로그 파일 출력이 비활성화되어 있으면 월드 및 사용자 정보가 동기화되지 않을 수 있습니다. VRChat 설정에서 로그 파일 출력이 활성화되도록 변경해 주세요."
        },
        "app_not_start": {
          "short_title": "앱이 실행되지 않음",
          "title": "사진 동기화 도구가 실행되지 않게 되었습니다",
          "step1": "알림 영역(작업 표시줄 오른쪽)에서 사진 동기화 도구가 실행 중인지 확인해 주세요.",
          "step2": "다른 앱(예: 백신 소프트웨어)의 간섭이나 PC 또는 드라이버 업데이트로 인해 실행되지 않을 수 있습니다.",
          "step2_note1": "최근 설치한 앱을 비활성화하거나 삭제한 뒤 다시 시도해 주세요.",
          "step2_note2": "문제가 해결되지 않으면 운영팀에 문의해 주세요."
        },
        "pause_delete": {
          "short_title": "일시정지·삭제",
          "title": "사진 동기화 도구를 일시정지하거나 삭제하고 싶습니다",
          "step1": "일시정지하려면 알림 영역의 사진 동기화 도구 아이콘을 클릭하여 \"대시보드\"를 열고 \"자동 업로드\" 스위치를 OFF로 설정해 주세요.",
          "step2": "종료하려면 알림 영역의 사진 동기화 도구 아이콘을 우클릭하고 \"Quit Metamory\"를 선택해 주세요.",
          "step3": "사진 동기화 도구를 완전히 중지하려면 Windows의 \"설정\" -> \"앱\" -> \"설치된 앱\"에서 \"Metamory Client\"를 제거해 주세요."
        },
        "vrchat_account": {
          "short_title": "VRChat 다른 계정",
          "title": "VRChat에 다른 계정으로 로그인했더니 자동 동기화가 되지 않습니다",
          "step1": "현재 Metamory는 VRChat의 여러 계정 간 사진 및 정보 동기화를 지원하지 않습니다. 사진을 수동으로 업로드하거나, 사진 동기화 도구를 설치할 때 사용했던 계정으로 자동 업로드를 계속 이용해 주세요."
        },
        "metamory_account": {
          "short_title": "Metamory 다른 계정",
          "title": "Metamory의 다른 계정을 만들었는데 자동 동기화가 되지 않습니다",
          "step1": "Metamory 사진 동기화 도구는 인증한 하나의 Metamory 계정에만 연결됩니다.",
          "step2": "연결할 계정을 변경하려면 대시보드의 \"설정\" -> \"계정\" -> \"사인아웃\" 버튼으로 사인아웃한 뒤 다시 인증해 주세요."
        }
      }
    }
  },
  "urge_reload": {
    "title": "페이지를 새로고침해 주세요",
    "description": "페이지가 업데이트되었습니다. 최신 정보를 보려면 페이지를 새로고침해 주세요.",
    "reload": "새로고침"
  },
  "plan": {
    "current_plan": "현재 플랜",
    "current_use_storage": "사용 중인 저장 공간",
    "storage_source": {
      "title": "스토리지 내역",
      "subscription": "구독",
      "promotions": "프로모션",
      "valid_until": "유효 기간: {{date}}",
      "no_promotions": "사용 중인 프로모션이 없습니다",
      "permanent": "무제한"
    },
    "payment_interval_annual_label": "연간 결제",
    "payment_interval_annual_discount": "{{percent}}% 할인",
    "discount_available": "할인 적용 가능",
    "payment_interval_monthly": "월간 결제",
    "storage_feature": "{{storage}}GB 추가 저장 공간",
    "price_format_annual": "¥{{price}}/년",
    "price_format_monthly": "¥{{price}}/월 (세금 포함)",
    "upgrade_plan": "{{planTitle}} 플랜으로 업그레이드",
    "downgrade_plan": "{{planTitle}} 플랜으로 다운그레이드",
    "features_earlyaccess": "새 기능 조기 이용",
    "features_fast_access": "예전 사진 빠른 접근",
    "features_original_image": "원본 이미지 저장",
    "features_ad_free": "광고 없는 환경",
    "price_with_discount": "¥{{price}}/월 ({{percent}}% 할인) (세금 포함)",
    "upgrade_to": "{{plan}} 플랜으로 업그레이드",
    "downgrade_to": "{{plan}} 플랜으로 다운그레이드",
    "enjoy_plan": "저장 공간과 기능을 더 즐겨보세요!",
    "back_to_plan": "플랜으로 돌아가기",
    "back_to_home": "홈으로 돌아가기",
    "failled_settle_title": "결제 처리에 실패했습니다",
    "failled_settle_description": "결제 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.\n이 문제가 반복되면 Metamory에 문의해 주세요",
    "processing_subscription_title": "구독 처리 중...",
    "processing_subscription_description": "잠시만 기다려 주세요. 곧 반영됩니다.",
    "subscription_timeout_title": "구독이 처리 중입니다",
    "subscription_timeout_description": "처리에 시간이 걸리고 있습니다. 곧 플랜에 반영되오니 잠시만 기다려 주세요.",
    "using_current_plan": "현재 플랜 사용 중",
    "annual_to_monthly_downgrade": "이 플랜으로 변경해도 이전 플랜({{current_plan_name}} (1년)) 결제 금액 ¥{{current_plan_price}}는 환불되지 않습니다.\nMetamory는 <b>{{recommended_plan_name}} (1년)</b> 플랜으로 업그레이드하는 것을 권장합니다. (¥{{recommended_plan_price}}로 업그레이드 가능)\n정말로 플랜을 변경하시겠습니까?",
    "limit_photos_num": "최대 {{num}}장",
    "free_price": "무료",
    "most_popular": "가장 인기",
    "savings_annual": "연간 {{num}}엔 절약",
    "management": {
      "header_title": "플랜 관리",
      "current_plan": "현재 플랜",
      "next_billing_date": "다음 청구일",
      "current_plan_expiration_date": "현재 플랜 만료일",
      "next_billing_amount": "다음 결제 금액",
      "payment_method": "결제 수단",
      "change_payment_method": "변경",
      "cancel_plan": "플랜 해지",
      "cancel_plan_already_canceled": "해지 완료",
      "resume_plan": "플랜 재개",
      "resume_plan_success": "플랜이 재개되었습니다.",
      "update_creditcard_success": "신용카드 정보를 업데이트했습니다",
      "update_creditcard_error": "신용카드 정보 업데이트에 실패했습니다",
      "par_one_year": "/ 1년",
      "par_one_month": "/ 1개월"
    },
    "cancel": {
      "title": "플랜을 해지하시겠습니까?",
      "message": "현재 플랜({{plan_name}})을 해지하려고 합니다.\n플랜을 해지하면 저장 공간 부족으로 인해 <b>{{photo_count}}장의 사진</b>이 삭제됩니다. 저장 공간이 부족한 동안 자동 사진 업로드도 일시 중지됩니다.",
      "date": "예상 종료일",
      "confirm_button": "플랜 해지",
      "cancel_button": "해지하지 않음",
      "confirm_message": "플랜을 해지하려면 확인을 위해 Metamory ID를 입력해 주세요.",
      "confirm_text": "플랜 해지",
      "confirm_ok": "해지하기",
      "success": "플랜이 해지되었습니다."
    },
    "downgrade": {
      "title": "플랜 변경",
      "message": "{{plan_name}} 플랜으로 변경하려고 합니다. 어떻게 하시겠습니까?\n플랜을 변경하면 저장 공간 부족으로 인해 {{photo_count}}장의 사진이 삭제됩니다. 저장 공간이 부족한 동안 자동 사진 업로드도 중지됩니다.",
      "confirm_button": "플랜 변경",
      "cancel_button": "변경하지 않음",
      "date": "변경일",
      "confirm_text": "플랜 변경",
      "success": "플랜이 변경되었습니다."
    },
    "confirm": {
      "title": "{{plan}} 플랜으로 변경하시겠습니까?",
      "charge_amount": "오늘 <b>{{amount}}</b> 이(가) 청구됩니다",
      "no_immediate_charge": "오늘 청구되는 금액이 없습니다",
      "next_billing_date": "다음 청구일",
      "confirm_and_charge": "동의하고 결제",
      "confirm": "변경",
      "cancel": "취소",
      "processing": "처리 중...",
      "preview_error": "청구 금액을 가져오지 못했습니다. 잠시 후 다시 시도해 주세요."
    }
  },
  "timeline": {
    "empty": {
      "main": {
        "title": "아직 사진이 없습니다",
        "message": "공개 앨범의 사진이 공유되면 여기에 표시됩니다.",
        "action": "사용자 찾기"
      },
      "me": {
        "title": "아직 사진을 게시하지 않았습니다",
        "message": "사진을 업로드해 추억을 공유해 보세요.",
        "action": "사진 업로드"
      },
      "noFriends": {
        "title": "아직 아무도 팔로우하지 않았습니다",
        "message": "사용자를 팔로우하면 타임라인에서 그들의 사진을 볼 수 있습니다.",
        "action": "사용자 찾기"
      },
      "noPhotos": {
        "title": "사진이 없습니다",
        "message": "이 타임라인에는 아직 사진이 없습니다."
      }
    }
  },
  "maintenance": {
    "title": "점검 중",
    "message": "현재 점검을 진행하고 있습니다.",
    "sub_message": "잠시만 기다려 주세요."
  },
  "report": {
    "album_unavailable": "현재 앨범 신고를 이용할 수 없습니다",
    "report": "신고",
    "report_photo": "사진 신고",
    "report_album": "앨범 신고",
    "report_user": "사용자 신고",
    "dialog_title_photo": "이 사진을 신고하시겠습니까?",
    "dialog_title_album": "이 앨범을 신고하시겠습니까?",
    "dialog_title_user": "이 사용자를 신고하시겠습니까?",
    "reason_label": "신고 사유",
    "reason_inappropriate_icon": "부적절한 아이콘 이미지",
    "reason_inappropriate_name": "부적절한 사용자 이름 / ID",
    "reason_inappropriate_bio": "부적절한 자기소개 텍스트",
    "reason_sexual_content": "성적인 콘텐츠",
    "reason_violence": "폭력적인 콘텐츠",
    "reason_harassment": "괴롭힘",
    "reason_other": "기타",
    "comment_placeholder": "자세한 내용을 입력해 주세요 (선택 사항)",
    "submit": "신고 제출",
    "cancel": "취소",
    "success": "신고가 성공적으로 제출되었습니다",
    "error": "신고 제출에 실패했습니다",
    "already_reported": "이미 신고한 항목입니다",
    "guidelines_link": "가이드라인",
    "guidelines_message": "신고하기 전에 <0>가이드라인</0>을(를) 확인해 주세요."
  },
  "sensitive": {
    "overlay_message": "민감한 콘텐츠",
    "show_button": "표시",
    "birth_date": "생년월일",
    "birth_date_input_title": "생년월일 설정",
    "birth_date_required": "생년월일은 필수입니다",
    "birth_date_invalid": "올바른 생년월일을 입력해 주세요",
    "birth_date_under_18": "18세 미만의 사용자는 표시할 수 없습니다",
    "birth_date_setting": "생년월일 설정",
    "birth_date_setting_description": "민감한 콘텐츠 표시에 사용됩니다",
    "birth_date_change_restriction": "생년월일은 3개월에 한 번 변경할 수 있습니다",
    "birth_date_dialog_description": "이 콘텐츠를 보려면 생년월일을 입력해 주세요.\n(설정 페이지에서 나중에 변경할 수 있습니다)",
    "global_filter_title": "민감한 콘텐츠 필터",
    "global_filter_description": "민감한 콘텐츠 표시를 제어합니다",
    "global_filter_enabled": "활성화",
    "global_filter_disabled": "비활성화",
    "global_filter_restriction_title": "설정 변경 불가",
    "global_filter_restriction_message": "18세 미만이거나 생년월일이 설정되지 않은 사용자는 민감한 콘텐츠 필터를 비활성화할 수 없습니다.",
    "birth_date_next_change_date": "다음 변경 가능일: {{date}}",
    "birth_date_save": "생년월일 저장",
    "birth_date_updated": "생년월일이 업데이트되었습니다",
    "sensitive_album_confirm_message": "민감한 콘텐츠가 포함된 앨범입니다.\n표시하시겠습니까?",
    "under_18_cannot_view_album": "18세 미만의 사용자는 이 콘텐츠를 볼 수 없습니다",
    "login_required_message": "민감한 콘텐츠가 포함된 앨범입니다.\n보려면 로그인이 필요합니다"
  },
  "muted": {
    "overlay_message": "음소거한 사용자",
    "show_button": "표시",
    "album_confirm_message": "음소거한 사용자가 소유한 앨범입니다.\n표시하시겠습니까?"
  },
  "common": {
    "loading": "로딩 중……"
  },
  "desktop_callback": {
    "redirecting": "Metamory 클라이언트로 리디렉션 중...",
    "redirecting_description": "브라우저에서 메시지가 표시되면 \"열기\"를 클릭하세요.",
    "having_trouble": "앱이 열리지 않나요?",
    "manual_description": "앱이 자동으로 열리지 않은 경우, 아래 코드를 복사하여 Metamory 클라이언트에 붙여넣으세요.",
    "copy": "복사",
    "copied": "복사됨",
    "expiry_warning": "이 코드는 약 5분 후에 만료됩니다.",
    "missing_params": "인증 매개변수를 찾을 수 없습니다. 클라이언트에서 다시 로그인하세요.",
    "expiry_warning_minutes_one": "이 코드는 약 {{count}}분 후에 만료됩니다.",
    "expiry_warning_minutes_other": "이 코드는 약 {{count}}분 후에 만료됩니다.",
    "open_client": "Metamory 클라이언트 열기",
    "never_share": "이 코드는 이 컴퓨터의 Metamory 데스크톱 앱에만 붙여넣으세요. Metamory 운영자를 사칭하는 사람을 포함해 누구에게도 알려주지 마세요."
  },
  "desktop_handoff": {
    "title": "데스크톱 앱에 로그인",
    "question": "{{name}}(으)로 Metamory 데스크톱 앱에 로그인하시겠습니까?",
    "description": "승인하면 이 컴퓨터의 Metamory 데스크톱 앱이 이 계정으로 로그인합니다. 데스크톱 앱에서 로그인을 시작하지 않았다면 취소하세요.",
    "approve": "승인",
    "cancelled_title": "로그인을 취소했습니다",
    "cancelled_description": "데스크톱 앱에는 아무것도 보내지 않았습니다. 이 탭을 닫아도 됩니다.",
    "invalid_params": "로그인 링크가 올바르지 않습니다. Metamory 데스크톱 앱에서 다시 로그인하세요.",
    "not_enabled": "이 환경에서는 데스크톱 앱 로그인이 활성화되어 있지 않습니다.",
    "failed": "데스크톱 앱 로그인을 준비하지 못했습니다. 다시 시도하세요",
    "error_title": "데스크톱 앱에 로그인할 수 없습니다",
    "framed": "이 페이지는 다른 페이지 안에서 열 수 없습니다. Metamory 데스크톱 앱에서 다시 로그인하세요.",
    "refused": "현재 로그인 상태에서는 데스크톱 앱 로그인을 사용할 수 없습니다.",
    "account_error": "계정 정보를 불러오지 못했습니다.",
    "not_you": "다른 계정을 사용하려면 로그아웃"
  },
  "history": {
    "disappeared": "더 이상 표시할 수 없는 기록이 있습니다.",
    "user": {
      "empty": "교류 기록이 없습니다",
      "empty_hint": "사진 동기화 도구를 다운로드하고 추억을 돌아보세요.",
      "more": "더 보기",
      "expand": "{{name}}님의 교류 기록 보기",
      "collapse": "{{name}}님의 교류 기록 닫기",
      "load_failed": "교류 기록을 불러오지 못했습니다."
    },
    "title": "교류 기록",
    "worlds": "월드",
    "users": "사용자",
    "search": {
      "worlds_placeholder": "월드 이름으로 기록 검색",
      "users_placeholder": "사용자 이름으로 기록 검색",
      "worlds_filter": "월드:",
      "users_filter": "사용자:",
      "cancel": "검색 취소",
      "clear": "검색 조건 해제",
      "change_named": "검색 조건 ‘{{name}}’ 변경",
      "loading": "후보 검색 중",
      "failed": "후보를 불러오지 못했습니다.",
      "empty": "일치하는 기록이 없습니다.",
      "refine": "후보가 50개를 넘습니다. 검색어를 더 구체적으로 입력해 주세요."
    },
    "coming_soon": "준비 중",
    "order": "정렬 순서",
    "newest": "최신순",
    "oldest": "오래된순",
    "show_available": "열람 가능한 기록 보기",
    "invalid_link": "시간대가 포함된 올바른 날짜와 시간을 입력해 주세요.",
    "outside_range": "요청한 날짜는 열람 가능한 기록 범위를 벗어났습니다.",
    "visit_missing": "이 방문을 찾을 수 없거나 현재 열람할 수 없습니다.",
    "empty": "아직 월드 방문 기록이 없습니다. 동기화 도구로 방문 기록을 동기화해 주세요.",
    "sync_tool": "동기화 도구 안내",
    "retry": "다시 시도",
    "index_changed": "방문 기록이 변경되었습니다. 새로 고침 후 다시 시도해 주세요.",
    "range_error": "이 범위의 기록을 불러오지 못했습니다.",
    "loading": "방문 기록을 불러오는 중",
    "scroll_date": "방문 날짜로 스크롤",
    "detail": {
      "expand": "방문 상세 열기",
      "collapse": "방문 상세 닫기",
      "open_world_url": "새 탭에서 월드 열기",
      "participant_count": "사용자 {{count}}명",
      "photo_count": "사진 {{count}}장",
      "duration": "{{hours}}시간 {{minutes}}분",
      "staying": "방문 중",
      "join": "입장",
      "leave": "퇴장",
      "other_participants": "외 {{count}}명",
      "all_participants": "참가자",
      "not_registered": "Metamory 미등록",
      "encounter_count_label": "만난 횟수",
      "last_encounter_label": "마지막으로 만난 날",
      "encounter_count": "{{count}}회",
      "open_profile": "프로필 보기",
      "profile_unavailable": "Metamory에 등록되지 않아 프로필을 표시할 수 없습니다.",
      "encounter_load_failed": "교류 정보를 불러오지 못했습니다.",
      "detail_load_failed": "방문 상세를 불러오지 못했습니다.",
      "visit_not_found": "이 방문을 찾을 수 없습니다.",
      "retry": "다시 시도",
      "open_photo": "{{date}}의 사진 열기",
      "timeline_truncated": "이후 기록은 생략되어 있습니다.",
      "create_my_album": "내 앨범 만들기",
      "album_name": "{{date}} {{world}}에서",
      "you": "나",
      "name_separator": ", ",
      "join_sentence": " 입장",
      "leave_sentence": " 퇴장",
      "show_participants": "참가자 {{count}}명 보기",
      "duration_hours": "{{hours}}시간"
    },
    "album_invitation_failed": "앨범은 생성되었지만 일부 초대에 실패했습니다. 대상을 조정하고 완료를 누르면 미완료 초대만 다시 시도합니다. 뒤로 가면 생성된 앨범이 열립니다.",
    "album_no_invitations": "이 공개 범위에서는 참가자를 초대하지 않습니다.",
    "album_invitation_limit": "초대 대기는 최대 100명입니다. 초대 대상을 100명 이하로 줄이거나 자동 승인을 활성화하세요."
  },
  "world": {
    "search_no_result": "월드를 찾을 수 없습니다",
    "search_no_result_description": "다른 월드 이름이나 식별자로 검색해 주세요.",
    "search_limit": "월드를 찾을 수 없나요?",
    "search_limit_description": "후보는 최대 50개까지 표시됩니다. 검색어를 추가해 범위를 좁혀 주세요."
  },
  "passkey": {
    "title": "패스키",
    "description": "패스키를 사용하면 비밀번호 대신 지문, 얼굴 인식, 화면 잠금으로 로그인할 수 있습니다. 패스키는 기기나 비밀번호 관리자에 저장됩니다.",
    "add": "패스키 추가",
    "added": "패스키를 추가했습니다",
    "empty": "아직 패스키가 없습니다",
    "empty_description": "패스키를 추가하면 다음부터 비밀번호 없이 로그인할 수 있습니다",
    "unnamed": "이름 없는 패스키",
    "created_at": "추가일: {{date}}",
    "attachment_platform": "기기 내장",
    "attachment_cross_platform": "보안 키 또는 다른 기기",
    "delete_named": "{{name}} 삭제",
    "delete_confirm": "\"{{name}}\"을(를) 삭제하시겠습니까?\n이 패스키로는 더 이상 로그인할 수 없습니다. 기기나 비밀번호 관리자에 남은 패스키는 각각의 설정에서 삭제해 주세요.",
    "deleted": "패스키를 삭제했습니다",
    "delete_failed": "패스키를 삭제하지 못했습니다",
    "list_error": "패스키 목록을 불러오지 못했습니다",
    "canceled": "패스키 요청이 취소되었습니다",
    "already_registered": "이 기기에는 이미 이 계정의 패스키가 있습니다",
    "not_supported": "이 브라우저 또는 기기에서는 패스키를 사용할 수 없습니다",
    "failed": "패스키를 사용할 수 없습니다. 잠시 후 다시 시도해 주세요",
    "limit_reached": "등록할 수 있는 패스키 수가 한도에 도달했습니다. 사용하지 않는 패스키를 삭제한 뒤 추가해 주세요",
    "nudge": "다음부터 지문이나 얼굴 인식으로 로그인할 수 있도록 패스키를 추가하시겠습니까?",
    "nudge_action": "추가"
  }
}
